import React, { Suspense, createContext, lazy, useCallback, useMemo } from 'react';
import { AuthProviderProps, Context, Provider } from './auth.types';

const MsalWrapper = lazy(() => import('./msal/msal.wrapper'));
const OidcClientWrapper = lazy(() => import('./oidc-client/oidc-client.wrapper'));

export const AuthContext = createContext<Context>(null);

const AuthProvider: Provider = ({ onLoading, children, configurations }: AuthProviderProps) => {
  const isMSAL = useMemo(() => configurations.type === 'msal' && configurations.dados, [configurations]);

  const Wrapper = useCallback(() => {
    if (isMSAL) {
      console.info('Seguindo com MSAL');
      return (
        <MsalWrapper configurations={configurations} onLoading={onLoading}>
          {children}
        </MsalWrapper>
      );
    }
    console.info('Seguindo no modo retro-compatível através do oidc-client');
    return (
      <OidcClientWrapper onLoading={onLoading} configurations={configurations}>
        {children}
      </OidcClientWrapper>
    );
  }, [isMSAL, configurations, onLoading, children]);

  return (
    <Suspense fallback={onLoading}>
      <Wrapper />
    </Suspense>
  );
};

export default AuthProvider;
